"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCompositeExpression = exports.isComparisonExpression = exports.isExpression = void 0;
const core_types_1 = require("@dqm/core-types");
function isExpression(input) {
    if (isComparisonExpression(input)) {
        return true;
    }
    if (isCompositeExpression(input)) {
        return true;
    }
    return false;
}
exports.isExpression = isExpression;
function isComparisonExpression(input) {
    if (!(0, core_types_1.isObject)(input))
        return false;
    if (typeof input.operator !== "string")
        return false;
    if (typeof input.field !== "string")
        return false;
    if ("value" in input === false)
        return false;
    return true;
}
exports.isComparisonExpression = isComparisonExpression;
function isCompositeExpression(input) {
    if (!(0, core_types_1.isObject)(input))
        return false;
    if (typeof input.operator !== "string")
        return false;
    if (!Array.isArray(input.operands))
        return false;
    return true;
}
exports.isCompositeExpression = isCompositeExpression;
//# sourceMappingURL=Expression.js.map